import React from 'react';
import PropTypes from 'prop-types';

import {greyishBlue500, greyishBlue900} from "assets/jss/main";
import {ReactComponent as WishibamLogo} from "assets/img/wishibam-logo.svg";

OrganizationName.propTypes = {
    organization: PropTypes.object,
    selected: PropTypes.bool
};

function OrganizationName({organization, selected = false}) {
    if (!organization) {
        return null;
    }

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center'
        }}>
            <div style={{
                width: '18px',
                height: '18px'
            }}>
                {organization?.customIcon ? (
                    <img
                        src={organization.customIcon}
                        alt={'organization logo'}
                        style={{
                            width: '18px',
                            height: '18px',
                            objectFit: 'contain'
                    }}
                    />
                ) : (
                    <WishibamLogo />
                )}
            </div>

            <span style={{
                marginLeft: '8px',
                fontSize: '14px',
                fontWeight: 600,
                color: selected ? greyishBlue900 : greyishBlue500
            }}>
                {organization.name}
            </span>
        </div>
    );
}

export default OrganizationName;
